import { render, staticRenderFns } from "./windspeed.vue?vue&type=template&id=ac90db58"
import script from "./windspeed.vue?vue&type=script&lang=js"
export * from "./windspeed.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports